"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    headerWrapper: {
      padding: spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      borderTop: "1px solid ".concat(palette.dividerLight)
    },
    listHeader: {
      textTransform: 'uppercase'
    },
    icon: {
      marginLeft: spacing(0.5)
    },
    skeleton: {
      display: 'inline-block',
      lineHeight: 1.8,
      width: 16,
      height: 20
    }
  };
});

var SelectHeader = function SelectHeader(_ref2) {
  var onChange = _ref2.onChange,
      value = _ref2.value,
      header = _ref2.header,
      entity = _ref2.entity,
      entitiesCount = _ref2.entitiesCount,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$headerProps = _ref2.headerProps,
      headerProps = _ref2$headerProps === void 0 ? {} : _ref2$headerProps;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    py: 3,
    pl: 6,
    pr: 2
  }, headerProps), header && /*#__PURE__*/_react.default.createElement(_material.Box, {
    pb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray"
  }, header)), /*#__PURE__*/_react.default.createElement(_ui.SearchField, {
    value: value,
    placeholder: "Search your ".concat(entity),
    onChange: onChange
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.headerWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)(classes.listHeader, 'Label-Table-Left-Active')
  }, "Your recent ", isLoading ? /*#__PURE__*/_react.default.createElement(_material.Skeleton, {
    className: classes.skeleton
  }) : entitiesCount, " ", entity), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    className: classes.icon,
    title: "Can\u2019t find your campaign from the most recent campaigns list? Please use the search field above."
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "info-circle",
    fontSize: 1,
    color: "text"
  }))));
};

var _default = /*#__PURE__*/(0, _react.memo)(SelectHeader);

exports.default = _default;